import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Odd, OddResult, getNameFromOddResult } from 'src/entities/Odd';
import { OddService } from 'src/services/odd.service';
import { ShowOddModalComponent } from './show-odd-modal/show-odd-modal.component';
import { EditOddModalComponent} from './edit-odd-modal/edit-odd-modal.component';
import { ChipColor } from "../../status-chip/status-chip.component";

@Component({
  selector: 'app-odds',
  templateUrl: './odds.component.html',
  styleUrls: ['./odds.component.css'],
})
export class OddsComponent implements OnInit {
  data: Odd[] = [];
  loading: boolean = false;
  searchedValue: string = '';
  // Columns to display
  displayedColumns: string[] = ['guid', 'name', 'value', 'event', 'oddtype', 'result', 'actions'];
  totalItems: number = 0;
  page: number = 1;
  orderBy: { field: string; direction: string } | null = null;
  MODAL_WIDTH: string = '100%';

  constructor(
    private oddService: OddService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {
    // Show user if needed
    if (this.activatedRoute.snapshot.params['guid']) {
      this.dialog.open(ShowOddModalComponent, {
        width: this.MODAL_WIDTH,
        data: {
          guid: this.activatedRoute.snapshot.params['guid'],
        },
      });
    }
  }

  ngOnInit(): void {
    // Set all data
    this.setData();
  }

  /**
   * Retrieve all data
   */
  setData(showLoader: boolean = true): void {
    this.loading = showLoader;

    // Retrieve data from API
    this.oddService.getOdds(this.getParams()).subscribe(
      (response: any) => {
        // Set all data
        this.data = response['hydra:member'];
        // Set the total count for the paginator
        this.totalItems = response['hydra:totalItems'];
      },
      () => null,
      () => {
        this.loading = false;
      }
    );
  }

  /**
   * Retrieve the params for the API
   */
  getParams(): any {
    let params: any = {};

    // Retrieve order by if it is set
    if (this.orderBy) {
      params[`order[${this.orderBy.field}]`] = this.orderBy.direction;
    }

    params['page'] = this.page;
    params['name'] = this.searchedValue;

    return params;
  }

  /**
   * Find a odd in the data by guid
   */
  getOddByGuid(guid: string): Odd | null {
    const index: number = this.data.findIndex(
      (odd: Odd) => odd.guid === guid
    );

    if (index !== -1) {
      return this.data[index];
    }
    return null;
  }

  /**
   * Change the order by val and reset the pagination on sort change
   */
  sortChange(odd: any): void {
    // Clear the order if no header is sorted
    if (odd.active === '' || odd.direction === '') {
      this.orderBy = null;
    } else {
      // Change the order
      this.orderBy = {
        field: odd.active,
        direction: odd.direction,
      };
    }
    // Reset the pagination
    this.page = 1;

    // Set all data
    this.setData(false);
  }

  setSearchedValue(odd: any): void {
    this.searchedValue = (odd.target as HTMLTextAreaElement).value;
    this.page = 1; // Reset page
    this.setData(false);
  }

  /**
   * Show the show odd modal
   */
  showOddModal(guid: string): void {
    console.log('show odd : ', guid);
    const odd: Odd | null = this.getOddByGuid(guid);
    if (odd) {
      this.dialog.open(ShowOddModalComponent, {
        width: this.MODAL_WIDTH,
        data: {
          guid: odd.guid,
        },
      });
    }
  }

  /**
   * Show the edit odd modal
   */
  editOddModal(guid: string | null = null): void {
    console.log('edit odd : ', guid);
    let odd: Odd | null = null;

    if (guid) {
      odd = this.getOddByGuid(guid);
      if (!odd) return;
    } else {
      odd = new Odd();
    }

    if (odd) {
      const dialogRef = this.dialog.open(EditOddModalComponent, {
        width: this.MODAL_WIDTH,
        data: {
          guid: odd.guid,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        // Refresh if changes has been made
        if (result?.hasBeenChanged) this.setData();
      });
    }
  }

  getChipColorFromResult(odd: Odd): ChipColor {
    switch (odd.result) {
      case OddResult.RESULT_CANCELLED:
        return ChipColor.BLACK;
      case OddResult.RESULT_WAITING:
        return ChipColor.ORANGE;
      case OddResult.RESULT_WON:
        return ChipColor.GREEN;
      case OddResult.RESULT_LOST:
        return ChipColor.RED;
      default:
        return ChipColor.GREY;
    }
  }

  getChipTooltipFromResult(odd: Odd): string {
    return getNameFromOddResult(odd.result);
  }
}
